import React, { useState } from 'react';
import styles from './ContactUs.module.css';
import usePageTracking from '../components/UsePageTracking';

function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: ''
  });
  const [submissionStatus, setSubmissionStatus] = useState(null); // 'success', 'error', 'submitting'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionStatus('submitting');

    try {
      // For form submission, FastAPI expects x-www-form-urlencoded, so use URLSearchParams
      const formBody = new URLSearchParams();
      for (const key in formData) {
        formBody.append(key, formData[key]);
      }

      const response = await fetch('/api/contact', { // Endpoint defined in FastAPI
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmissionStatus('success');
        setFormData({ name: '', email: '', company: '', subject: '', message: '' }); // Clear form
      } else {
        const errorData = await response.json();
        console.error('Contact form submission error:', errorData);
        setSubmissionStatus('error');
      }
    } catch (error) {
      console.error('Network or server error:', error);
      setSubmissionStatus('error');
    }
  };

  const calendlyLink = "https://calendly.com/talk2boardai"; // REPLACE with your actual Calendly link

  usePageTracking();

  return (
    <div className={styles.contactUsPage}>
      <section className={styles.heroContact}>
        <h1>Connect With Our Team. Begin Your AI Journey.</h1>
        <p>We're eager to understand your challenges and explore how Talk2Board AI can help drive your strategic objectives. Reach out to us directly or schedule a call.</p>
      </section>

      <section className={styles.contactContent}>
        <div className={styles.contactInfo}>
          <h2>Get in Touch</h2>
          <p>Whether you have a specific project in mind, want to discuss a challenge, or simply learn more about our services, we're here to help.</p>
          <div className={styles.infoItem}>
            <strong>Email:</strong> <a href="mailto:info@talk2board.com">info@talk2board.com</a>
          </div>
          <div className={styles.socialLinks}>
            <a href="https://linkedin.com/company/talk2boardai" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i> LinkedIn
            </a>
            {/* Add other social icons if needed */}
          </div>
          <div className={styles.calendlySection}>
            <h3>Prefer a Direct Consultation?</h3>
            <p>Book a convenient time directly with our team to discuss your specific needs.</p>
            <a href={calendlyLink} target="_blank" rel="noopener noreferrer" className="btn-primary">
              Book a Consultation
            </a>
          </div>
        </div>

        <div className={styles.contactFormContainer}>
          <h2>Send Us a Message</h2>
          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Your Name</label>
              <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="email">Your Email</label>
              <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="company">Company </label>
              <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="message">Your Message</label>
              <textarea id="message" name="message" rows="6" value={formData.message} onChange={handleChange} required></textarea>
            </div>
            <button type="submit" className="btn-primary" disabled={submissionStatus === 'submitting'}>
              {submissionStatus === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>
            {submissionStatus === 'success' && <p className={styles.successMessage}>Thank you for your message! We will get back to you shortly.</p>}
            {submissionStatus === 'error' && <p className={styles.errorMessage}>Failed to send message. Please try again or contact us directly.</p>}
          </form>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;